<template>
  <div>
    <van-nav-bar
        title="余额"
        left-arrow
        class="my-nav"
        :fixed="true"
        @click-left="$router.back(-1)"
    />

    <div style="margin-top: 50px;color: blue">
      <van-cell-group class="user-group" v-for="wallet in walletInfo">
        <van-cell :title="wallet.shopName"/>
        <van-cell title="总余额" :value="fen2yuan(wallet.totalBalance) + ' 元'"/>
        <van-cell title="押金" :value="fen2yuan(wallet.deposit) + ' 元'"/>
        <van-cell title="可用余额" :value="fen2yuan(wallet.balance) + ' 元'" value-class="money"/>
        <van-cell v-for="(v,k) in wallet.meta" :title="k" :value="fen2yuan(v) + ' 元'" value-class="money"/>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import {getBalanceInfo} from '../../api/balance'

export default {
  data() {
    return {
      walletInfo: ''
    }
  },
  mounted() {

    getBalanceInfo(data => {
      this.walletInfo = data
    })
  },
  methods: {
    fen2yuan(fen) {
      return parseFloat(fen / 100).toFixed(2);
    },
  }
}
</script>

<style lang="less" scoped>
.money{
  color: #ee0a24;
}
</style>
